// extracted by mini-css-extract-plugin
export var quillEditor = "_ni-1";
export var variable = "_ni-0";